import React, { useState } from "react";
import { Link } from "react-router-dom";
import {encode as base64_encode} from 'base-64';
import { getFirstLetter, notifyError, notifySuccess } from "../../helper";
import client from "../../api";
import { MAIL_ACCOUNT_ALL_LINK, 
    RECONNECT_GOOGLE_ACCOUNT_LINK, 
    EDIT_SMTP_SLUG,CAMPAIGN_CALENDAR_LINK, 
    CREATE_GOOGLE_SMTP_ACCOUNT_LINK,
    EDIT_GOOGLE_SMTP_ACCOUNT_LINK } from "../../constants/constants";
import DataLoader from "../DataLoader";


const MailBox = (props) => {
    const api = client();
    const data = props.data;    
    const handleWarmupClick = props.handleWarmupClick

    const disableMailAccount = async (email) => {
        try{
            const response = await api.post('/v1/mailAccount/disable',{
                email:email
            });
            if(response.status === 200 || response.status === 201){
                notifySuccess('Mail account is disabled');
                setTimeout(function(){
                    window.location.href = MAIL_ACCOUNT_ALL_LINK;
                 },2000);
            }

        } catch (error) {
            console.log('error.message',error);
            if(error.status === 400){
                notifyError('Bad Request. Not able to disable the mail account. Please try again');
            }
        }
    }
    const enableMailAccount = async (email) => {
        try{
            const res = await api.post('/v1/mailAccount/enable',{
                email:email
            });
            if(res.status === 200 || res.status === 201){
                notifySuccess('Mail account is enabled');
                setTimeout(function(){
                    window.location.href = MAIL_ACCOUNT_ALL_LINK;
                 },2000);
            }
        } catch (error) {
            console.log('error.message',error);
            if(error.status === 400){
                notifyError('Bad Request. Not able to enable the mail account. Please try again');
            }
        }
    }

    return(<>
        <div className="mail-box">
            <div className="top-block">
                <div className="left-part"> 
                    <div className="first-char">
                        <i>{getFirstLetter(data.name)}</i>
                    </div>
                    <div className="mail-address">
                        <div className="name-row">
                        <span className="account-name">{data.name}</span> 
                        {data.status === 'inactive' ? <span className="is-disabled"><i>Disabled</i></span>:''}
                        </div>
                        <span className="account-email">{data.email}</span>                            
                    </div>
                </div>
                <div className="right-part">
                    <div className="dot-menu-wrap">
                        <span className="dots"><i className='bx bx-dots-vertical-rounded'></i></span>
                        <div className="bot-menu">
                            <ul>
                                {data.type === "google" && <li><Link to={`${RECONNECT_GOOGLE_ACCOUNT_LINK}?email=${data.email}&name=${data.name}`}>Reconnect</Link></li>}
                                {data.type === "google" && <li>{ data.has_smtp ? <Link to={`${EDIT_GOOGLE_SMTP_ACCOUNT_LINK.replace(':emailID',data.id)}`}>Edit SMTP</Link> : <Link to={`${CREATE_GOOGLE_SMTP_ACCOUNT_LINK.replace(':emailID',data.id)}`}>Add SMTP</Link>}</li>}
                                {data.type === "smtp" && <li><Link to={`${EDIT_SMTP_SLUG}${base64_encode(data.email)}`}>Edit connection</Link></li>}
                                {data.status === 'active' && <li><span onClick={()=>{disableMailAccount(data.email)}}>Disable</span></li>}
                                {data.status === 'inactive' && <li><span onClick={()=>{enableMailAccount(data.email)}}>Enable</span></li>}
                                {data.status === 'active' && (
                                    <li>
                                        <span onClick={() => handleWarmupClick(data.id)}>
                                            Check Warmup
                                        </span>
                                    </li>
                                )}
                                <li><span onClick={()=>{
                                    props.setEmailAddress(data.email);
                                    props.setShowAccountDeleteModelWindow(true)}}>Delete</span></li>
                            </ul>
                        </div>
                    </div>
                    <div className="mail-calendar">
                    <Link to={`${CAMPAIGN_CALENDAR_LINK}/${base64_encode(data.email)}`}><i className='bx bxs-calendar'></i></Link>
                    </div>
                </div>
            </div>
            <div className="box-content">
                <div className="signature" dangerouslySetInnerHTML={{__html:data.signature.length ? data.signature: '(No signature set)'}}></div>
            </div>
            <div className="bottom-block">
                <div className="account-type">                
                { data.type === "google" && <img src='./../../assets/images/google-mail-icon.svg' alt="g suite icon" /> }
                { data.type === "smtp" && <img src='./../../assets/images/smtp-mail-icon.svg' alt="smtp icon" /> }
                </div>
                {data.status === 'stopped' ? <div className="account-status">
                    <i className='bx bxs-error'></i>
                    <p>This account is stopped. Please {data.type === "smtp" ? <Link to={`${EDIT_SMTP_SLUG}${base64_encode(data.email)}`}>click here</Link> : <Link to={`${RECONNECT_GOOGLE_ACCOUNT_LINK}?email=${data.email}&name=${data.name}`}>click here</Link> } to Reauthenticate.</p>
                </div> : '' }
                <div className="edit-action">
                    <span 
                        onClick={()=>{
                            props.handleEditClick(data);
                        }}><i className='bx bxs-edit' ></i></span>
                </div>
            </div>
        </div>        
    </>);
}

export default MailBox;